<template>
    <div class="fillform" v-loading.fullscreen.lock="loading" v-loading="loading">
   <p>苏 格 兰 学 院 学 风 督 察 记 录 表</p>
        <div class="mainHeader">
         <div class="oneline">
            <el-form :inline="true"  :model="formInline" class="demo-form-inline">
            <el-form-item label="授课教师">
                <el-input v-model="formInline.teacher" placeholder="授课教师"></el-input>
            </el-form-item>
            <el-form-item label="所在单位">
                <el-input v-model="formInline.teacherUnit" placeholder="教师所在单位"></el-input>
            </el-form-item>
                    <el-form-item label="教师职称">
                <el-input v-model="formInline.teacherTitle" placeholder="教师职称"></el-input>
            </el-form-item>
            <el-form-item label="年龄层次">
                <el-select v-model="formInline.teacherAgeLevel" placeholder="年龄层次">
                <el-option label="老(>55)" value="55"></el-option>
                <el-option label="中(35-55)" value="35"></el-option>
                <el-option label="青(20-35)" value="20"></el-option>
                </el-select>
            </el-form-item>
            
            </el-form>
        </div>
    
        <div class="oneline">
            <el-form :inline="true"  :model="formInline" class="demo-form-inline">
            <el-form-item label="课程名称">
                <el-input v-model="formInline.courseTitle" placeholder="课程名称"></el-input>
            </el-form-item>
            <el-form-item label="课程类型">
                <el-select v-model="formInline.courseType" placeholder="课程类型">
                <el-option label="公共基础课" value="class1"></el-option>
                <el-option label="专业基础课" value="class2"></el-option>
                <el-option label="专业课" value="class3"></el-option>
                <el-option label="实验课" value="class4"></el-option>
                <el-option label="实习实训" value="class5"></el-option>
                </el-select>
            </el-form-item>
            <!-- <el-form-item>
                <el-button type="primary" @click="onSubmit">查询</el-button>
            </el-form-item> -->
            </el-form>
        </div>
        
    
       
        <div class="oneline">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
            <el-form-item label="授课日期">
                <el-input v-model="formInline.lecturesData" placeholder="X年　 X月 X日 星期X 第X周"></el-input>
            </el-form-item>
                      <el-form-item label="授课节次">
                <el-select v-model="formInline.section" placeholder="当天第几节次">
                <el-option label="8:00-8:45" value="1"></el-option>
                <el-option label="9:00-9:45" value="2"></el-option>
                <el-option label="10:00-10:45" value="3"></el-option>
                <el-option label="11:00-11:45" value="4"></el-option>
                <el-option label="13:00-13:45" value="5"></el-option>
                <el-option label="14:00-14:45" value="6"></el-option>
                <el-option label="15:00-15:45" value="7"></el-option>
                <el-option label="16:00-16:45" value="8"></el-option>
    
                </el-select>
            </el-form-item>
            <el-form-item label="授课班级">
                <el-input v-model="formInline.lecturesClass" placeholder="授课班级"></el-input>
            </el-form-item>
              <el-form-item label="授课地点">
                <el-input v-model="formInline.lecturesAddress" placeholder="授课地点"></el-input>
            </el-form-item>
  
            
            </el-form>
        </div>
    
    
       <div class="metainfoFeedback">
            <!-- <p>课程主要内容</p> -->
            <el-form>
              
             <el-form-item label="课程主要内容"> 
               
                    <el-input   type="textarea"  style="width:1050px"  :rows="3"   placeholder="请输入课程主要内容（可多行）"   v-model="formInline.lecturesContent"> </el-input>
              </el-form-item>
            </el-form>
       </div>
  
  
      </div>
       <div class="assessformTeacher" v-loading="loading">
           <div class="leftform_T">
               <div style="padding-top:350px">
                <span class="textvert">学生上课情况</span>
                 <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
          </div>
          </div>
          
            
               <div class="midform_T">
                    <div style="padding-top:60px;padding-left:40px;padding-bottom:20px">
                <p>学习态度</p></div>
                <!-- <el-divider></el-divider> -->
                   <div style="padding-top:130px;padding-left:40px">
                  <p>学习行为</p></div>
                  <!-- <el-divider></el-divider> -->
                     <div style="padding-top:230px;padding-left:40px">
                    <p>学习方法</p></div>
                    <!-- <el-divider></el-divider> -->
                       <div style="padding-top:100px;padding-left:40px">
                      <p>学习效果</p></div>
                       <!-- <el-divider></el-divider> -->
                           <div style="padding-top:80px;padding-left:40px">
                      <p>学生上课综合评价</p></div>
                 <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
               
               </div>
    
                
              <div class="Rightform_T">
                  <div class="oneline" v-loading="loading">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="尊重老师、学习态度端正，师生关系融洽">
                            <el-radio-group v-model="formInline.respectTeacher">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment1" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
                 <div class="oneline">
                    <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                        <el-form-item label="认真预复习、听课精神饱满，课堂气氛活跃">
                            <el-radio-group v-model="formInline.studentingZeal">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment2" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                 
                    </div>
                  <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="遵守课堂教学秩序、保持课堂环境整洁">
                            <el-radio-group v-model="formInline.discipline">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment3" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
                       <!-- <el-divider></el-divider> -->
                 <div class="oneline">
                    <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                        <el-form-item label="不迟到、不早退、不无故旷课、课中不无故出入教室">
                            <el-radio-group v-model="formInline.noBeLate">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment4" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                   
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="师生互动频繁，同学间互帮互助">
                            <el-radio-group v-model="formInline.interaction">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment5" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
     
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="注意力集中，做好课堂教学笔记">
                            <el-radio-group v-model="formInline.concentrate">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment6" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="参与各类课堂教学活动">
                            <el-radio-group v-model="formInline.pedagogical">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment7" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
  
                                    <el-divider></el-divider>
                   
                 <div class="oneline">
                    <el-form :inline="true"  :model="formInline" class="demo-form-inline">
                        <el-form-item label="认真思考，主动提问">
                            <el-radio-group v-model="formInline.askQuestions">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                          <el-form-item>                     <el-input v-model="formInline.comment8" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                
                    </div>
                 <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="积极发言，课堂气氛活跃">
                            <el-radio-group v-model="formInline.classActive">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment9" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
               <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="利用多种教学资源和教育技术">
                        <el-radio-group v-model="formInline.rationalUtilization">
                        <el-radio label="好"></el-radio>
                        <el-radio label="较好"></el-radio>
                        <el-radio label="一般"></el-radio>
                        <el-radio label="差"></el-radio>
                        </el-radio-group>
                     </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.comment10" placeholder="补充评论（可选）"></el-input>
                    </el-form-item>
                    
                    </el-form>
                      <!-- <el-divider></el-divider> -->
             </div>
  
                          <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="课堂教学内容理解和掌握">
                        <el-radio-group v-model="formInline.understand">
                        <el-radio label="好"></el-radio>
                        <el-radio label="较好"></el-radio>
                        <el-radio label="一般"></el-radio>
                        <el-radio label="差"></el-radio>
                        </el-radio-group>
                     </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.comment11" placeholder="补充评论（可选）"></el-input>
                    </el-form-item>
                    
                    </el-form>
                    
             </div>
  
                          <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="相关知识和能力得到扩充和培养">
                        <el-radio-group v-model="formInline.capacity">
                        <el-radio label="好"></el-radio>
                        <el-radio label="较好"></el-radio>
                        <el-radio label="一般"></el-radio>
                        <el-radio label="差"></el-radio>
                        </el-radio-group>
                     </el-form-item>
                    <el-form-item>
                        <el-input v-model="formInline.comment12" placeholder="补充评论（可选）"></el-input>
                    </el-form-item>
                    
                    </el-form>
                      <el-divider></el-divider>
             </div>
  
                         <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="对学生上课情况的综合评价">
                            <el-radio-group v-model="formInline.listenComprehensive">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment13" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
    
    
          </div> 
        </div>
    
       <div class="assessformstudent"  v-loading="loading" >
            <div class="leftform_S">
                    <div style="padding-top:80px;padding-left:50px">
                <p>教师授课情况</p>
                 <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
            </div>
             </div>
             <div class="Rightform_S">
                       <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="遵守教师守则和教学纪律 （不迟到、不早退、师范表率）">
                            <el-radio-group v-model="formInline.teacherNoBeLate">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment14" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
    
                <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="教学组织和教学管理能力">
                            <el-radio-group v-model="formInline.doCapacity">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment15" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
    
              <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label="课堂内容熟练，授课方法得当，激发思考，教学效果好">
                            <el-radio-group v-model="formInline.teachGood">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment16" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                </div>
    
               <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item  label="对教师授课情况的综合评价" class="item"  >
                            <el-radio-group v-model="formInline.teachComprehensive">
                                <el-radio label="好"></el-radio> <el-radio label="较好"></el-radio> <el-radio label="一般"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment17" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                </div>
    
            </div>
        </div>
          
         <div class="assessformTeacher" v-loading="loading">
            <div class="leftform_All">
                  <div style="padding-top:0px;padding-left:50px">
                <p>总体评价</p>
                 <!-- <input class="multiinput" placeholder="placeholder"> </input> -->
            </div>
            </div>
             <div class="Rightform_All">
                  
         <div class="oneline">
                    <el-form :inline="true" :model="formInline" class="demo-form-inline">
                        <el-form-item label=" ">
                            <el-radio-group v-model="formInline.comprehensive">
                                <el-radio label="优"></el-radio> <el-radio label="良"></el-radio> <el-radio label="中"></el-radio> <el-radio label="差"></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>                     <el-input v-model="formInline.comment18" placeholder="补充评论（可选）"></el-input>                </el-form-item>
                    </el-form>
                    </div>
             </div>
             </div>
    
        <div class="metainfoFeedback" v-loading="loading">
        <el-form>
             <el-form-item label="存在问题及改进建议">
                 
                    <el-input   type="textarea"  style="width:1100px"  :rows="3"   placeholder="请输入存在问题及改进建议（可多行）"   v-model="formInline.problem"> </el-input>
            </el-form-item>
       </el-form>
           
            
       </div>
      <div class="mainHeader">
         <div class="oneline" v-loading="loading">
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                  <!-- <el-divider></el-divider> -->
            <el-form-item label="听课人">
                <el-input v-model="formInline.lecturesUser" placeholder="听课人"></el-input>
            </el-form-item>
            <el-form-item v-show="false" label="用户名">
                <el-input v-model="formInline.username" placeholder="用户名"></el-input>
            </el-form-item>
            <el-form-item label="职务">
                <el-input v-model="formInline.position" placeholder="职务"></el-input>
            </el-form-item>
              <el-form-item label="时间">
                <el-input v-model="formInline.writDate" placeholder="时间"></el-input>
            </el-form-item>
            <!-- <el-form-item label="时间">
                <el-select v-model="formInline.region" placeholder="时间">
                <el-option label="8:00-8:45" value="1"></el-option>
                <el-option label="9:00-9:45" value="2"></el-option>
                <el-option label="10:00-10:45" value="3"></el-option>
        
                </el-select>
            </el-form-item> -->
               <!-- <el-divider></el-divider> -->
            </el-form>
        </div>
    </div>
        
    
      <el-dialog
    :visible.sync="dialogVisible"
    width="90%"
   >
  <el-button type="primary" @click="onSubmit">提交</el-button>
  <el-button type=" primary" @click="dialogVisible=false">取消</el-button>
  </el-dialog>
    </div>
    
    
    </template>
    
    <script>

    export default {
        props: ['formInline'],

  
  }
    </script>
    
  <style scoped>
    
    .fillform{
    
        width:100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        border: 1px;
        padding-top: 30px;
    }
    .oneline{
        display: flex;
        flex-direction: column;
        /* height:100px; */
    }
    .singleinput{
        width:200px;
        height:20px ;
        margin-top: 15px;
        margin-left: 45px;
    }
    
    .multiinput{
        width:800px;
        height:80px ;
          margin-top: 15px;
        margin-left: 35px;
    }
    .metainfo
    {
        width:100%;
        height: 100px;
        display: flex;
        border: 2px;
        flex-direction: column;
    
    
    }
    .metainfo1
    {
        width:400px;
        height: 45px;
        display: flex;
        border: 1px;
    
    }
    .leftform_T{
        width:120px;
        height:900px;
          padding:10px;
        background-color:rgb(185, 212, 203);
        /* text-align:justify;
        vertical-align:middle; */
    }
    .leftform_S{
        width:270px;
        height:250px;
         padding:10px;
         padding-right:30px;
        background-color:rgb(202, 230, 219);
    }
    
    .leftform_All{
          width:270px;
        height:40px;
         padding:10px;
         padding-right:30px;
        background-color:rgb(107, 146, 130);
    }
    .midform_T{
        width:150px;
        height:900px;;
        padding:10px;
        background-color:rgba(153, 194, 197, 0.418);
    }
    .Rightform_T{
        width: 930px!important;
        height:900px;
        padding:10px;
        background-color:rgba(186, 230, 233, 0.418);
    }
    .Rightform_S{
        width:930px;
        height:250px;;
        padding:10px;
        background-color:rgba(186, 230, 233, 0.618);
    }
    .Rightform_All{
        width:930px;
        height:40px;;
        padding:10px;
        background-color:rgba(128, 161, 163, 0.418);
    }
    .midform_S{
       width:150px;
        height:400px;;
        padding:10px;
        background-color:rgba(153, 194, 197, 0.418);
    }
    .eachquestionform{
        width: 40%;
        height:40%;
        display: flex;
        flex-direction: column;
    }
    .assessformTeacher
    {
        display: flex;
        flex-direction: row;
        width: 100%;
        padding-top:0px;
    
        
    }
    .assessformstudent
    {
        display: flex;
        flex-direction: row;
        width: 100%;
        height: 40%;
    
    
        
    }
    .textvert{
        padding-top: 200px;
    }
    .metainfoFeedback
    {
        width:100%;
        height: 120px;
        display: flex;
         flex-direction: column;
        border: 1px;
        margin-top:15px;
    }
    .actionButton{
    
        display: flex;
        padding-left:400px;
        padding-bottom: 20px;
        padding-top: 20px;
        
    }
    
    
    .item .el-form-item__label{
            color: #aaaa33;
        }
    .label-content .el-form-item__content{
            font-size: 20px;
            color: #aaaa33;
        }
    el-form-item >>>.el-form-item__label{
            color: #aaaa33;
        }
    .label-content .el-form-item__content{
            font-size: 20px;
            color: #aaaa33;
        }
  
  .mainHeader{
          background-color: rgb(235, 226, 228);
          padding-top: 30px; 
      }
    
    </style>


// WEBPACK FOOTER //
// src/components/work/teacher/ComponentsSupervise.vue